/* eslint-disable @typescript-eslint/no-unused-vars */
import { css } from '@emotion/react'
import { FC } from 'react'
import { Field } from 'react-final-form'

import { FieldLabelProps } from '../atoms/FieldLabel'

export type Props = {
  name: string
  isConfirm: boolean
  initialValue?: boolean
} & FieldLabelProps

const CheckBox: FC<Props> = ({
  name,
  isConfirm,
  label,
  initialValue = false,
}) => {
  return (
    <div>
      <label css={checkBoxStyle}>
        <Field
          name={name}
          component='input'
          type='checkbox'
          disabled={isConfirm}
          initialValue={initialValue}
        />
        <div className='indicator'></div>
        <span style={{ color: '#FFF' }}>{label}</span>
      </label>
    </div>
  )
}

export default CheckBox

const checkBoxStyle = css`
  display: flex;
  align-items: center;
  gap: 5px;
  position: relative;
  padding-left: 20px;
  font-size: 14px;

  input {
    /* appearance: auto; */
    margin: 0;
    padding: 0;
    background: none;
    border: none;
    border-radius: 0;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  input:checked ~ .indicator {
    background: #fbe21f;

    &::after {
      content: '';
      position: absolute;
      display: block;
      left: 8px;
      top: 4px;
      width: 3px;
      height: 8px;
      border: solid #000;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
  }

  .indicator {
    background: #fff;
    position: absolute;
    top: 3px;
    left: 0;
    height: 20px;
    width: 20px;
  }
`
